const VisualStaticLoadingModalEnum = {
  VISUAL_STATIC_LOADING_MODAL_EXPORT_URL_SET: 'VISUAL_STATIC_LOADING_MODAL_EXPORT_URL_SET',
  VISUAL_STATIC_LOADING_MODAL_OPEN: 'VISUAL_STATIC_LOADING_MODAL_OPEN',
  VISUAL_STATIC_LOADING_MODAL_REDIRECT_TO_EXPORT_URL: 'VISUAL_STATIC_LOADING_MODAL_REDIRECT_TO_EXPORT_URL',
};

export const VisualStaticLoadingModalWaitTimesBeforeRedirect = {
  CHECKMARKS: 7000,
  ICONS: 10000,
};

export default VisualStaticLoadingModalEnum;



// WEBPACK FOOTER //
// ./src-react/Modals/VisualStaticLoadingModal/VisualStaticLoadingModalConstants.jsx